export default "__VITE_ASSET__DOvtFWvx__"